import { lazy } from 'react';

export const History = lazy(() => import('./ui/History'));
